if (!customElements.get('cart-cross-sell-item')) {
  customElements.define(
    'cart-cross-sell-item',
    class CartCrossSellItem extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('button');
        this.label = this.querySelector('.cart-cross-sell__add-label');
        this.successLabel = this.querySelector('.cart-cross-sell__add-success');
        this.spinner = this.querySelector('.loading__spinner');

        if (!this.button) return;

        this.button.addEventListener('click', this.onAddClick.bind(this));
      }

      onAddClick() {
        if (this.button.getAttribute('aria-disabled') === 'true' || this.button.disabled) return;

        this.button.setAttribute('aria-disabled', 'true');
        this.spinner.classList.remove('hidden');

        const body = JSON.stringify({
          items: [{ id: this.dataset.variantId, quantity: 1 }],
        });

        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .then((response) => {
            this.spinner.classList.add('hidden');

            if (response.status) {
              this.button.removeAttribute('aria-disabled');
              return;
            }

            this.label.hidden = true;
            this.successLabel.hidden = false;

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-cross-sell',
              cartData: response,
            });
          })
          .catch(() => {
            this.spinner.classList.add('hidden');
            this.button.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
